"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});

var core_1 = require("@dynamynd/core");

var redux_observable_1 = require("redux-observable");

var rxjs_1 = require("rxjs");

var operators_1 = require("rxjs/operators");

var actions_1 = require("../actions");

exports.getUserProfileSuccessEpic = function (actions$) {
  return actions$.pipe(redux_observable_1.ofType(actions_1.UserActionTypes.GET_USER_PROFILE_SUCCESS), operators_1.mergeMap(function (_a) {
    var payload = _a.payload;
    return getUserProfileSuccessEpicHandler(payload);
  }), operators_1.catchError(core_1.defaultErrorHandler));
};

function getUserProfileSuccessEpicHandler(_a) {
  var userProfile = _a.userProfile;
  return rxjs_1.of(actions_1.setUserProfileActionCreator(userProfile));
}